exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Colors */\n/* Sizes */\n/* Breakpoints */\n/* Mobile */\n/* Fonts */\nh1 {\n  color: #fff;\n  font-size: 43px;\n  line-height: 54px;\n  font-weight: 300;\n  text-align: center;\n  text-transform: uppercase;\n  padding-bottom: 500px;\n}\nh1 span {\n    display: block;\n    font-weight: 700;\n    margin-bottom: 10px;\n}\n", ""]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js??ref--3-oneOf-0-1!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader??ref--0!./src/apps/kiosk/components/KioskMain.vue?vue&type=style&index=0&lang=scss&module=true&
// module id = Cv2+
// module chunks = 3